import React from 'react';
import { Box, Button, Container } from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';
import weaverLogo from '../../assets/weaver_logo.svg';

const LandingHeader = ({ handleLoginClick, isTransitioning, scrollY }) => (
  <Box
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      borderBottom: 1,
      borderColor: 'rgba(100, 200, 255, 0.3)',
      backdropFilter: 'blur(20px)',
      background: 'rgba(232, 244, 253, 0.95)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
      opacity: isTransitioning ? 0 : 1,
      transform: isTransitioning ? 'translateY(-100px)' : `translateY(${scrollY > 100 ? -scrollY * 0.1 : 0}px)`,
      transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)'
    }}
  >
    <Container maxWidth="lg">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            component="img"
            src={weaverLogo}
            alt="Weaver AI"
            sx={{ height: 40, width: 'auto', filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))' }}
          />
        </Box>
        <Button
          variant="contained"
          startIcon={<LoginIcon />}
          onClick={handleLoginClick}
          disabled={isTransitioning}
          sx={{
            borderRadius: 3,
            px: 3,
            py: 1,
            textTransform: 'none',
            fontWeight: 600,
            background: 'linear-gradient(45deg, #1976d2, #1565c0)',
            boxShadow: '0 4px 15px rgba(25, 118, 210, 0.3)',
            '&:hover': {
              background: 'linear-gradient(45deg, #1565c0, #1976d2)',
              boxShadow: '0 6px 20px rgba(25, 118, 210, 0.5)',
              transform: 'translateY(-2px)'
            },
            transition: 'all 0.3s ease',
            '&:disabled': { opacity: 0.7, transform: 'scale(0.95)' }
          }}
        >
          {isTransitioning ? 'Transitioning...' : 'Login'}
        </Button>
      </Box>
    </Container>
  </Box>
);

export default LandingHeader;
